import { Box, FormControl, Input, Stack, Tag } from "@chakra-ui/react"
import { ErrorMessage, Formik } from "formik"
import { ComponentProps, FC, useState } from "react"
import { ErrorMessageField } from "src/components/ui"
import { DrawerForm } from "src/components/ui/DrawerForm"
import { InputLabel } from "src/components/ui/InputLabel"
import { IItemCategory } from "src/domain/entities"
import { fetchGujaratiSuggestions } from "src/utils/helpers"
import { FormikOnSubmit } from "src/utils/types"
import { IItemCategoryUpdateFormFields } from "."

interface Props extends Omit<ComponentProps<typeof DrawerForm>, "children"> {
	itemCategory: IItemCategory
	handleSubmit: FormikOnSubmit<IItemCategoryUpdateFormFields>
}

export const ItemCategoryUpdateDrawerFormView: FC<Props> = ({
	itemCategory,
	handleSubmit,
	...rest
}) => {
	const [nameSuggestions, setNameSuggestions] = useState<string[]>([])

	return (
		<Formik<IItemCategoryUpdateFormFields>
			initialValues={{
				name: itemCategory.name,
				note: itemCategory.note,
				slug: itemCategory.slug,
			}}
			onSubmit={handleSubmit}
			enableReinitialize={true}
		>
			{({ values, isSubmitting, handleChange, setFieldValue }) => {
				const handleNameChange = async (
					e: React.ChangeEvent<HTMLInputElement>,
				) => {
					setFieldValue("name", e.target.value)
					const suggestions = await fetchGujaratiSuggestions(e.target.value)
					setNameSuggestions(suggestions)
				}

				return (
					<DrawerForm
						size="sm"
						headerLabel="Update Item Category"
						submitLabel="Save"
						isSubmitting={isSubmitting}
						{...rest}
					>
						<Stack maxWidth={"sm"} marginX={"auto"}>
							{/* Name */}
							<FormControl>
								<InputLabel label="Item Category Name" />
								<Input
									name="name"
									placeholder="Name"
									maxLength={100}
									required
									autoFocus
									value={values.name}
									onChange={handleNameChange}
								/>
								<ErrorMessage component={ErrorMessageField} name="name" />
							</FormControl>
							{/* Slug */}
							<FormControl>
								<InputLabel label="Slug" />
								<Input
									name="slug"
									placeholder="Slug"
									maxLength={100}
									required
									value={values.slug}
									onChange={handleChange}
								/>
								<ErrorMessage component={ErrorMessageField} name="slug" />
							</FormControl>
							<Box>
								{nameSuggestions.map((el, i) => (
									<Tag
										colorScheme={"green"}
										backgroundColor={"green.50"}
										variant="outline"
										_hover={{
											backgroundColor: "green.100",
										}}
										cursor="pointer"
										margin={0.5}
										onClick={() => {
											setFieldValue("name", el)
											setNameSuggestions([])
										}}
										key={i}
									>
										{el}
									</Tag>
								))}
							</Box>
							{/* Note */}
							<FormControl>
								<InputLabel label="Note" />
								<Input
									name="note"
									placeholder="Note"
									maxLength={100}
									value={values.note}
									onChange={handleChange}
								/>
								<ErrorMessage component={ErrorMessageField} name="note" />
							</FormControl>
						</Stack>
					</DrawerForm>
				)
			}}
		</Formik>
	)
}
